import { z } from 'zod';

import { RULE_KEYS, SEVERITIES } from '../enums';

export const RuleConfigUpdateSchema = z
  .object({
    value: z.union([z.number().nonnegative(), z.boolean()]).optional(),
    enabled: z.boolean().optional(),
    severity: z.enum(SEVERITIES).optional(),
    overridable: z.boolean().optional(),
    notes: z.string().max(500).optional(),
  })
  .refine((data) => Object.keys(data).length > 0, {
    message: 'At least one rule field must be supplied.',
  });

export const RuleKeyParamSchema = z.object({
  key: z.enum(RULE_KEYS),
});

export type RuleConfigUpdateInput = z.infer<typeof RuleConfigUpdateSchema>;
